<template>
	<div>
		<div class="one_01">
			<!-- <div class="one_02" @click="clickBack">
					<i class="el-icon-arrow-left one_03"></i>
					<el-divider direction="vertical"></el-divider>
				</div> -->
			<div class="one_04">
				<el-tabs v-model="activeTabChange" @tab-click="handleTabClick">
					<el-tab-pane v-for="item in tabList" :key="item.key" :label="item.value" :name="item.key">
						<template #label>
							<span v-if="item.isPush" class="isPush">{{ item.value }}</span>
							<span v-else>{{ item.value }}</span>
						</template>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div class="pd20">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "TopTab",
	props: {
		activeTab: {
			type: String,
			default: "1"
		},
		tabData: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			tabList: [],
			activeTabChange: this.activeTab
		};
	},
	components: {},
	mounted() {
		this.tabList = this.tabData.filter((item) => !item.isHide);
	},
	methods: {
		// 显示
		showTopTab(data) {
			this.tabList = data.filter((item) => !item.isHide);
		},
		// tab切换
		handleTabClick() {
			// 同时 emit kebab 与 camel 两个事件名，兼容 @tab-change 与 @tabChange
			this.$emit("tab-change", this.activeTabChange);
			this.$emit("tabChange", this.activeTabChange);
		},

		// 点击返回
		clickBack() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped>
.one_01 {
	height: 48px;
	background: var(--app-surface);
	display: flex;
	align-items: center;
	padding: 0 16px;
	border: 1px solid var(--app-border);
	border-bottom: none;
	border-radius: 12px 12px 0 0;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
}

.one_02 {
	height: 100%;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.one_03 {
	font-size: 18px;
	font-weight: 700;
}

.one_04 {
	height: 100%;
	display: flex;
	align-items: center;
	margin-left: 12px;
	font-size: 12px;
	padding-top: 8px;
	overflow: hidden;
}

.isPush {
	padding: 0px !important;
}

.isPush::before {
	content: "";
	width: 0px;
	height: 15px;
	position: absolute;
	top: 12px;
	left: 0px;
	border-left: 2px solid #afabab;
	transform: rotateZ(20deg);
}

.pd20 {
	background: var(--app-surface);
	border: 1px solid var(--app-border);
	border-top: none;
	border-radius: 0 0 12px 12px;
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.03);
	display: flex;
	flex-direction: column;
	overflow: auto;
	padding: 0 16px 16px;
	height: calc(100vh - 130px);
}
</style>
